import { render, staticRenderFns } from "./AiaAgent.vue?vue&type=template&id=324aafdf"
import script from "./AiaAgent.vue?vue&type=script&lang=js"
export * from "./AiaAgent.vue?vue&type=script&lang=js"
import style0 from "./AiaAgent.vue?vue&type=style&index=0&id=324aafdf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports